<template>
  <div class="order-list">
    <div v-for="item in list" :key="item.id">
      <div class="order-item">
        <div class="order-item-content">
          <!-- 卸货不论品种，都需要提交送货单 -->
          <div v-if="item.txhlb == '卸货'">
            <div class="bpm-status" v-if="item.sfscxhzybd === '1'">
              <van-tag type="danger">送货单未上传</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.sfscxhzybd === '2'">
              <van-tag type="warning">送货单审核中</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.sfscxhzybd === '3'">
              <van-tag type="primary">送货单已审核，请按时取票</van-tag>
            </div>
          </div>
          <!-- 提货，只有危险物品需要上传电子运单 -->
          <div v-else>
            <div class="bpm-status" v-if="item.sfscdzyd === '1'">
              <van-tag type="danger">电子运单未上传</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.sfscdzyd === '2'">
              <van-tag type="warning">电子运单审核中</van-tag>
            </div>
            <div class="bpm-status" v-else-if="item.sfscdzyd === '3'">
              <van-tag type="primary">电子运单已审核，请按时取票</van-tag>
            </div>
          </div>

          <div class="content-item">车头号: {{item.chetouhao}}</div>
          <div class="content-item">车挂号: {{item.cheguahao}}</div>
          <div class="content-item">预约日期: {{item.pdrq}} {{item.pdsjd}}</div>
          <div class="content-item">货主:{{item.huozhu}}</div>
          <div class="content-item" v-if="(item.txhlb) == '提货'">提货单位: {{item.thdw}}</div>
          <div class="content-item">品名:{{item.pinzhong}}</div>
          <div class="content-item">作业类别:{{item.txhlb}}</div>
          <div class="content-item">司机:{{item.jsyxx}}</div>
        </div>

        <div class="order-footer">
          <router-link :to="{ name: 'orderdetail', params: { id: item.id }}">
            <van-button type="info" size="small" class="orderInfo">订单详情</van-button>
          </router-link>
            <span class="uploadth" v-if="item.txhlb ==='卸货' && item.sfscxhzybd === '1'">
              &nbsp;&nbsp;
              <router-link :to="{ name: 'uploadDelivery', params: { id: item.id }}">
                <van-button type="info" size="small" class="orderInfo">上传送货单</van-button>
              </router-link>
            </span>
            <span v-if="item.txhlb ==='提货' && (item.sfscdzyd) == 1" class="uploadth">
              &nbsp;&nbsp;
              <router-link :to="{ name: 'uploadth', params: { id: item.id }}">
                <van-button type="info" size="small" class="orderInfo">上传电子运单</van-button>
              </router-link>
            </span>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    list: {
      type: Array,
      default: function() {
        return []
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.bpm-status {
    float: right;
}
.order-list {
    background: none;
    .order-item {
        //margin: 0.375rem;
        margin: 0 1rem;
        margin-top: 1rem;
        padding: 0.625rem 1rem;
        overflow: hidden;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .order-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 0.46rem;
            color: #323233;
            .order-name {
                margin-bottom: 10px;
                font-weight: bold;
                font-size: 14px;
                line-height: 20px;
            }
            .content-item {
                line-height: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .order-item-desc {
            padding: 0.25rem 0.5rem;
            font-size: 14px;
            border-top: 0.03rem dashed #ebedf0;
        }
    }
    .order-footer {
        text-align: right;
    }
}
</style>
